import { render, staticRenderFns } from "./52zhdl.vue?vue&type=template&id=d9cd4d84&"
import script from "./52zhdl.vue?vue&type=script&lang=js&"
export * from "./52zhdl.vue?vue&type=script&lang=js&"
import style0 from "./52zhdl.vue?vue&type=style&index=0&id=d9cd4d84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports